import { delay } from './time'

export function encodeData(text: string): string {
  const data = String(text).replace(/(\r\n|\r|\n)/g, '\n')
  const lines = data.split(/\n/)

  let line = ''
  let output = ''

  for (let i = 0, l = lines.length; i < l; ++i) {
    line = lines[i]

    output += `data: ${
      line === '[DONE]' ? line : JSON.stringify({ content: line })
    }`
    output += i + 1 === l ? '\n\n' : '\n'
  }

  return output
}

export interface SseMessage {
  event?: string
  retry?: number
  id?: string
  data: string
}

export function formatEvent(message: SseMessage | string): string {
  const msg = typeof message === 'string' ? { data: message } : message

  let output = ''
  if (msg.event) {
    output += `event: ${msg.event}\n`
  }

  if (msg.retry) {
    output += `retry: ${msg.retry}\n`
  }

  if (typeof msg.id === 'string' || typeof msg.id === 'number') {
    output += `id: ${msg.id}\n`
  }

  output += encodeData(msg.data)

  return output
}

export type OnChunkCallback = (chunk: string) => void

const DEFAULT_TEXT = [
  `[Pay Attention: This is a mock sse response]`,
  `Used by some of the world's largest companies, Next.js enables you to create full-stack Web applications by extending the latest React features, and integrating powerful Rust-based JavaScript tooling for the fastest builds. 👪😃😂👌👑👸`,
].join(' ')

export const getBasicStream = (text = DEFAULT_TEXT) => {
  const textArr = text.split('')
  return async (onChunk: OnChunkCallback) => {
    for (let i = 0; i < textArr.length; i++) {
      onChunk(formatEvent({ data: `${textArr[i]}` }))
      await delay(10)
    }

    onChunk(formatEvent({ event: 'done', data: '[DONE]' }))
  }
}
